import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from '@/store/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import less from 'less'
import locale from 'element-ui/lib/locale/lang/en'
import 'default-passive-events'
// import './element-variables.less'
import './theme/index.css'
import './assets/css/global.css'
import {
  message
} from '@/api/resetMessage';

// main.js
import websocket  from '../src/ws/ws'
Vue.prototype.$WebSocket = websocket


import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.config.silent = true
let GmapVue = require('gmap-vue');
import { components } from 'gmap-vue';
ElementUI.Dialog.props.closeOnPressEscape.default = false;
Vue.component('gmap-cluster', components.Cluster);
Vue.use(GmapVue, {
  autoBindAllEvents: false,
  installComponents: true,
  dynamicLoad: false,
});
Vue.prototype.$EventBus = new Vue()
Vue.use(ElementUI, { locale })
Vue.use(ElementUI);
Vue.prototype.$message = message;
Vue.use(less)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
// if (process.env.NODE_ENV === 'development') {
// }
